import {ConfigurationApplication} from '@application/Config';

export const getAppSchema = (): string => {
  const {tradename} = ConfigurationApplication.retrieve();
  return `${tradename.toLowerCase()}://`;
};
